

























































import { Component, Prop, Vue } from 'vue-property-decorator';

import Modal from '@/components/common/Modal.vue';
import { UserWallet } from '@/store/wallet/types';

@Component({
  name: 'balance-modal',
  components: {
    Modal,
  },
})
export default class BalanceModal extends Vue {
  @Prop({ default: true }) private modalOpen: Boolean;
  @Prop({ default: null, required: true }) private onClose: Function;
  @Prop({ default: null, required: true }) private userWallet: UserWallet;

  get walletURL() {
    return process.env.VUE_APP_EXPORO_WALLET_URL;
  }
}
